import './Footer.css';
import React  from 'react';

export default function Footer() {
    return (
        <footer id="contact">
            <p>&copy; 2025 Snackstrology. All rights reserved. <a href="#terms">Terms and Privacy</a></p>
        </footer>
    );
}